import React, { useState } from 'react';
import {createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification } from 'firebase/auth';
import { auth } from './firebase-config';
import { useTranslation } from 'react-i18next';
import './SignIn.css';

function SignIn() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [resetEmail, setResetEmail] = useState(''); // For password reset
    const [isResettingPassword, setIsResettingPassword] = useState(false); // Toggle password reset input

    // function signInWithGoogle() {
    //     const signInAttempt = signInWithPopup(auth, provider);
    //     signInAttempt.then((result) => {
    //         if (result.user.emailVerified) {
    //             console.log('Signed in with popup:', result.user);
    //         } else {
    //             alert(t('emailNotVerified'));
    //             auth.signOut();
    //         }
    //     }).catch((error) => {
    //         handleAuthError(error);
    //     });
    // }

    function handleAuthError(error) {
        if (error.code === 'auth/popup-blocked') {
            console.error('Popup blocked by browser:', error);
            alert(t('popupBlockedByBrowser'));
        } else {
            console.error('Authentication error:', error);
            alert(error.message);
        }
    }

    function handleEmailSignIn() {
        signInWithEmailAndPassword(auth, email, password)
            .then((result) => {
                if (result.user.emailVerified) {
                    console.log('User signed in:', result.user);
                } else {
                    alert(t('emailNotVerified'));
                    auth.signOut();
                }
            })
            .catch(handleAuthError);
    }

    function handleEmailRegister() {
        createUserWithEmailAndPassword(auth, email, password)
            .then((result) => {
                console.log('User registered:', result.user);
                sendEmailVerification(result.user)
                    .then(() => {
                        console.log('Verification email sent.');
                        alert(t('verificationEmailSent'));
                        auth.signOut();
                    })
                    .catch(handleAuthError);
            })
            .catch(handleAuthError);
    }

    function handlePasswordReset() {
        sendPasswordResetEmail(auth, resetEmail)
            .then(() => {
                alert(t('passwordResetEmailSent'));
                setIsResettingPassword(false); // Hide the reset input after sending email
                setResetEmail(''); // Clear the input field
            })
            .catch(handleAuthError);
    }

    return (
        <div className="auth-container">
            <div className="email-auth">
                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
                <input
                    type="text"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                />
                <button onClick={handleEmailSignIn}>
                    {t('signIn')}
                </button>
                <button onClick={handleEmailRegister}>
                    {t('register')}
                </button>
                <button onClick={() => setIsResettingPassword(!isResettingPassword)}>
                    {t('forgotPassword')}
                </button>
                {isResettingPassword && (
                    <div className="password-reset">
                        <input type="text" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} placeholder={t('enterEmailToResetPassword')} />
                        <button onClick={handlePasswordReset}>{t('resetPassword')}</button>
                    </div>
                )}
            </div>
            {/* <button className="sign-in-button" onClick={signInWithGoogle}>
                {t('signInWithGoogle')}
            </button> */}
        </div>
    );
}

export default SignIn;
